import React, { useState, useEffect,useCallback } from "react";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  Button,
  MasterDetail,
  StateStoring,
  Pager,
  Paging,
} from "devextreme-react/data-grid";
import Button1 from "@material-ui/core/Button";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import "whatwg-fetch";
import { useStyles } from "../../Styles.js";
import { createStore } from "devextreme-aspnet-data-nojquery";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import { api_path } from "../../shared.js";
import Guid from "devextreme/core/guid";
import Select from "react-select";
import { useNavigate } from "react-router";
import DateBox from "devextreme-react/date-box";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import useDeviceSize from "../../hooks/useDeviceSize";
import InquiryMasterDetailView from "./InquiryMasterDetailView";
export function SaleInquiryDataGrid(props) {
  const [width, height] = useDeviceSize();
  const [loadPanelEnabled, setLoadPanelEnabled] = useState(true);
  const onContentReady = useCallback(() => {
    setLoadPanelEnabled(false);
  }, []);
  const classes = useStyles();
     //const [getUserRole] = useState('1');
  //             const [getCrmId, setCrmId] = useState('95');
  // const [getUserID, setUserID] = useState('surat.c@sinologistics.co.th');
  //        const [getCrmId, setCrmId] = useState('53');
  //const [getUserID, setUserID] = useState('supassara.j@sinologistics.co.th');
  //  const [getCrmId, setCrmId] = useState('65');
  // const [getUserID, setUserID] = useState('puttipat.t@sinologistics.co.th');
  // const [getCrmId, setCrmId] = useState('94');
  // const [getUserID, setUserID] = useState('raweenun.m@sinologistics.co.th');
   const [getUserRole] = useState(props.USER_ROLE);
    const [getCrmId, setCrmId] = useState(props.CRM_ID);
  const [getUserID, setUserID] = useState(props.USER_EMAIL);
  const [searchParams] = useSearchParams();
  const status_param = searchParams.get("status");
  const [isButtonDisabled, setButtonDisabled] = useState(true);
  const [getShipper, setShipper] = useState([]);
  const [getCommodity, setCommodity] = useState([]);
  const [getSearchStatus, setSearchStatus] = useState(0);
  const [getTotalCount, setTotalCount] = useState(0);
  const [getLoadGrid, setLoadGrid] = useState();
  const [getStatus, setStatus] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [selectStatus, setSelectStatus] = useState([]);

  const [getResult, setResult] = useState("");
  const [getErrMsg, setErrMsg] = useState("");
  const pageSizes = [25, 50, 100];
  const [selectedValue, setSelectedValue] = useState("option1");
  const [getDateStr, setDateStr] = useState(
    "Please click Search button to refresh data."
  );
  const [getSale, setSale] = useState([]);
  const [saleList, setSaleList] = useState([]);
  const [selectSale, setSelectSale] = useState([]);
  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  var date = new Date();

  if (status_param > 0) {
    var firstDay = new Date(date.getFullYear() - 1, date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  } else {
    var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  const formattedfirstDay = firstDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");

  const formattedlastDay = lastDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");

  const [getDateFrom, setDateFrom] = useState(formattedfirstDay);
  const [getDateTo, setDateTo] = useState(formattedlastDay);
  const [getMinDate, setMinDate] = useState(null);
  const [showSelect, setShowSelect] = useState(false);
  const navigate = useNavigate();
  const url =
    api_path +
    "/SALES_INQUIRY.php?sales=" +
    selectSale +
    "&userid=" +
    getUserID +
    "&userrole=" +
    getUserRole +
    "&status=" +
    selectStatus +
    "&parDateFrom=" +
    getDateFrom +
    "&parDateTo=" +
    getDateTo;
  const token = process.env.REACT_APP_API_TOKEN;
  const salesinquirydataSource = createStore({
  key: 'INQUIRY_ID',
  loadUrl: url,
  reshapeOnPush: true,
  onBeforeSend(method, ajaxOptions) {
    ajaxOptions.crossDomain = true;
    ajaxOptions.xhrFields = { withCredentials: true };
    ajaxOptions.headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  },
});
  const onValueChangedDateFrom = React.useCallback((e) => {
    setSearchStatus(0);
    const dateFrom = new Date(e.value);
    const formattedDateFrom = dateFrom
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateFrom(formattedDateFrom);
    setMinDate(formattedDateFrom);
    setShipper(null);
    setCommodity(null);
  }, []);
  const onValueChangedDateTo = React.useCallback((e) => {
    setSearchStatus(0);
    const dateTo = new Date(e.value);
    const formattedDateTo = dateTo
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateTo(formattedDateTo);
    setShipper(null);
    setCommodity(null);
  }, []);

  useEffect(() => {
    if (status_param > 0) {
      setSelectStatus(status_param);
    }

    if (getUserRole == 1) {
      //sales
        fetchSale();
      setButtonDisabled(true);
      // setSelectSale(getUserID);
      // setSale({
      //   EmpEmail: getUserID,
      //   EmpEmail: getUserID,
      // });
    } else if (getUserRole == 2) {
      //sales co
      setButtonDisabled(true);
      fetchSale();
    } else if (getUserRole == 4 || getUserRole == 9) {
      //pricing
      setButtonDisabled(false);
      fetchSale();
      setUserID("");
    } else if (getUserRole == 3 || getUserRole == 7) {
      setButtonDisabled(true);
      fetchSale();
      setUserID("");
    }
  }, []);
     const fetchSale = async () => {
    try {
      const response = await axios.get(`${api_path}/GET_SALES.php`, {
        params: {
          role: getUserRole,
          user: getCrmId,
        },
      });
      const saleData = response.data;
      setSaleList(saleData);

      //ถ้ามีตัวเลือกเดียว ให้ตั้งค่าทันที
      if (saleData.length === 1) {
        setSelectSale(saleData[0].SALE_NAME);
        setSale({
          SALE_CODE: saleData[0].SALE_NAME,
          SALE_NAME: saleData[0].SALE_NAME,
        });
      }
    } catch (error) {
      console.error("Error fetching sales data:", error);
    }
  };
  // const fetchSale = () => {
  //   axios
  //     .get(api_path + `/sales.php`)
  //     .then((response) => {
  //       setSaleList(response.data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  const fetchSaleByUSERID = () => {
    axios
      .get(
        api_path +
          `/INQUIRY_GETSALES.php?roleid=` +
          getUserRole +
          `userid=` +
          getUserID
      )
      .then((response) => {
        setSaleList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleSaleChange = (obj) => {
    setSelectSale(obj.SALE_NAME);
    setSale({ SALE_NAME: obj.SALE_NAME, SALE_NAME: obj.SALE_NAME });
  };

  function formatDate(value) {
    let date = new Date(value);
    const day = date.toLocaleString("default", { day: "2-digit" });
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.toLocaleString("default", { year: "numeric" });
    return day + "-" + month + "-" + year;
  }
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  const handleSearch = (e) => {
    setLoadGrid(randomNumberInRange(1, 20));
  };
  const handleClearInputClick = () => {
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    setSale([]);
    setSelectSale([]);
    setStatus([]);
    setSelectStatus([]);
    setDateFrom(formattedfirstDay);
    setDateTo(formattedlastDay);
    setResult("");
    setDateStr("");
    setTotalCount(0);
  };
  const handleStatusChange = (obj) => {
    setSelectStatus(obj.value);
    setStatus({ value: obj.value, label: obj.label });
  };
  const columnChooserModes = [
    {
      key: "dragAndDrop",
      name: "Drag and drop",
    },
    {
      key: "select",
      name: "Select",
    },
  ];
  const handleAddButtonClick = React.useCallback((e) => {
    window.open("/s-crm/SaleInquiryForm","_blank");
  }, []);
  const onCopyButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    window.open("/s-crm/SaleInquiryForm?copy=1&param1=" + e.row.key, "_blank");
  }, []);
  const onEditButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    window.open("/s-crm/SaleInquiryDetail?param1=" + e.row.key, "_blank");
  }, []);
  const onEmailButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    window.open("/s-crm/SendInquiry?order_id=" + e.row.key, "_blank");
  }, []);
  const onRatingButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    window.open("/s-crm/SaleInquiryDetail?param1=" + e.row.key, "_blank");
  }, []);
  const searchEditorOptions = { placeholder: "Search column" };
  const columnChooserModeLabel = { "aria-label": "Column Chooser Mode" };
  const cellPrepared = (e) => {
    if (e.rowType === "data") {
      if (
        e.column.dataField === "STATUS_NAME" &&
        e.data.STATUS_ID == 1 //new
      ) {
        e.cellElement.innerHTML =
        "<p style='color: #FFF; background-color: #FB6A00; text-align:center;font-weight: bold;line-height: 25px;margin:5px 0px;'><a href='SaleInquiryDetail?param1=" +
        e.row.key +
        "'  title='View detail' target='_blank' style='color: #FFF;'>" +
        e.data.STATUS_NAME +
        "</a></p>";
      
      } else if (
        e.column.dataField === "STATUS_NAME" &&
        e.data.STATUS_ID == 2 //Processing
      ) {
        e.cellElement.innerHTML =
        "<p style='color: #FFF; background-color: #0078d4; text-align:center;font-weight: bold;line-height: 25px;margin:5px 0px;'><a href='SaleInquiryDetail?param1=" +
        e.row.key +
        "'  title='View detail' target='_blank' style='color: #FFF;'>" +
        e.data.STATUS_NAME +
        "</a></p>";
      
      } else if (
        e.column.dataField === "STATUS_NAME" &&
        e.data.STATUS_ID == 3 //Done
      ) {
        e.cellElement.innerHTML =
        "<p style='color: #FFF; background-color: #A5BF00; text-align:center;font-weight: bold;line-height: 25px;margin:5px 0px;'><a href='SaleInquiryDetail?param1=" +
        e.row.key +
        "'  title='View detail' target='_blank' style='color: #FFF;'>" +
        e.data.STATUS_NAME +
        "</a></p>";
      } else if (
        e.column.dataField === "STATUS_NAME" &&
        e.data.STATUS_ID == 4 //Reject
      ) {
        e.cellElement.innerHTML =
        "<p style='color: #FFF; background-color: red; text-align:center;font-weight: bold;line-height: 25px;margin:5px 0px;'><a href='SaleInquiryDetail?param1=" +
        e.row.key +
        "'  title='View detail' target='_blank' style='color: #FFF;'>" +
        e.data.STATUS_NAME +
        "</a></p>";
      } else if (
        e.column.dataField === "STATUS_NAME" &&
        e.data.STATUS_ID == 5 //Complete
      ) {
        e.cellElement.innerHTML =
        "<p style='color: #FFF; background-color: #119f4a; text-align:center;font-weight: bold;line-height: 25px;margin:5px 0px;'><a href='SaleInquiryDetail?param1=" +
        e.row.key +
        "'  title='View detail' target='_blank' style='color: #FFF;'>" +
        e.data.STATUS_NAME +
        "</a></p>";
      } else if (
        e.column.dataField === "STATUS_NAME" &&
        e.data.STATUS_ID == 6 //Close
      ) {
        e.cellElement.innerHTML =
        "<p style='color: #FFF; background-color: #04646C; text-align:center;font-weight: bold;line-height: 25px;margin:5px 0px;'><a href='SaleInquiryDetail?param1=" +
        e.row.key +
        "'  title='View detail' target='_blank' style='color: #000;'>" +
        e.data.STATUS_NAME +
        "</a></p>";
       
      } else if (e.column.dataField === "Business_name" && e.data.Business_name == "SEA") {
        e.cellElement.innerHTML = "<p style='text-align:left;'>🚢 SEA</p>";
      } else if (e.column.dataField === "Business_name" && e.data.Business_name == "REEFER") {
        e.cellElement.innerHTML = "<p style='text-align:left;'>🧊 REEFER</p>";
      } else if (e.column.dataField === "Business_name" && e.data.Business_name == "AIR") {
        e.cellElement.innerHTML = "<p style='text-align:left;'>✈️ AIR</p>";
      } else if (e.column.dataField === "Business_name" && e.data.Business_name == "BREAKBULK") {
        e.cellElement.innerHTML = "<p style='text-align:left;'>🏭 BREAKBULK</p>";
      } else if (e.column.dataField === "Business_name" && e.data.Business_name == "TANK") {
        e.cellElement.innerHTML = "<p style='text-align:left;'>🧱 TANK</p>";
      } else if (e.column.dataField === "Business_name" && e.data.Business_name == "SOC") {
        e.cellElement.innerHTML = "<p style='text-align:left;'>🤵🏻 SOC</p>";
      } else if (e.column.dataField === "COMMODITY" && e.data.COMMODITY == "GARMENT") {
        e.cellElement.innerHTML = "<p style='text-align:left;'>👗 GARMENT</p>";
      } else if (e.column.dataField === "COMMODITY" && e.data.COMMODITY == "FAK") {
        e.cellElement.innerHTML = "<p style='text-align:left;'>📦 FAK</p>";
      } else if (e.column.dataField === "COMMODITY" && e.data.COMMODITY == "CHEMICAL") {
        e.cellElement.innerHTML = "<p style='text-align:left;'>🧪 CHEMICAL</p>";
        } else if (e.column.dataField === "COMMODITY" && e.data.COMMODITY == "FOOD") {
          e.cellElement.innerHTML = "<p style='text-align:left;'>🍽️ FOOD</p>";
        } else if (e.column.dataField === "COMMODITY" && e.data.COMMODITY == "TIRE") {
          e.cellElement.innerHTML = "<p style='text-align:left;'>⚫ TIRE</p>";
      } else if (e.column.dataField === "BELL" && e.data.BELL == "Y") {
        e.cellElement.innerHTML =
          "<a href='SaleInquiryDetail?param1=" +
          e.row.key +
          "' title='Positive' target='_blank'>🟢</a>";
      } else if (e.column.dataField === "BELL" && e.data.BELL == "N") {
        e.cellElement.innerHTML =
          "<a href='SaleInquiryDetail?param1=" +
          e.row.key +
          "' title='Negative' target='_blank'>🔴</a>";
      } else if (e.column.dataField === "BELL" && e.data.BELL == "C") {
        e.cellElement.innerHTML =
          "<a href='SaleInquiryDetail?param1=" +
          e.row.key +
          "'  title='View Comment' target='_blank'>💬</a>";
      } else if (e.column.dataField === "BELL" && e.data.BELL == "R") {
        e.cellElement.innerHTML =
  "<a href='SaleInquiryDetail?param1=" +
  e.row.key +
  "' title='View Comment' target='_blank'>" +
  "<span class='comment-wrapper'>" +
  "<span class='comment-icon'>💬</span>" +
  "<span class='comment-alert'>*</span>" +
  "</span></a>";
        // e.cellElement.innerHTML =
        //   "<a href='SaleInquiryDetail?param1=" +
        //   e.row.key +
        //   "'  title='View Comment' target='_blank'><span class='comment-red'>💬</span></a>";
      } else if (e.column.dataField === "BELL" && e.data.BELL == "E") {
        e.cellElement.innerHTML = "";
   
       
      }
    }
  };
  const checkBellPositive = (status) =>
    status && ["Y"].indexOf(status.trim().toUpperCase()) >= 0;
  const isBellPositiveVisible = (e) => checkBellPositive(e.row.data.BELL);
  const customizeBell = (cellInfo) => {
    if (cellInfo.value === "Y") {
      return "🟢";
    } else if (cellInfo.value === "N") {
      return "🔴";
    // } else if (cellInfo.value === "C") {
    //   return "💬";
    } else if (cellInfo.value === "E") {
      return "";
    } else {
      return cellInfo.valueText;
    }
  };
  const customizeText = (cellInfo) => {
    if (
      cellInfo.value === "1900-01-01 00:00:00.000" ||
      cellInfo.value === "" ||
      cellInfo.value === null ||
      cellInfo.value === undefined
    ) {
      return "-";
    } else {
      return cellInfo.valueText;
    }
  };
  // const isComplete = (status) =>
  //   status && ["3"].indexOf(status.trim().toUpperCase()) >= 0;
  // const isRatingIconVisible = (e) => isComplete(e.row.data.STATUS_ID);
  // const isPricing = (getUserRole) =>
  //   getUserRole && [4].indexOf(getUserRole.trim().toUpperCase()) >= 0;
  // const isCopyIconVisible = (e) => isPricing(getUserRole);

  const isPricing = (status) =>
    status && ["4"].indexOf(status.trim().toUpperCase()) >= 0;
  const isCopyIconVisible = (e) => !isPricing(getUserRole);


  const checkEmailVisible = (ORDERSTATUS) => { 
    if (getUserRole==4) {
      //if (ORDERSTATUS ==1 && getUserRole==4) {
        return true;
      } else {
        return false;
      }
  };
  const isEmailIconVisible = (e) =>
    checkEmailVisible(e.row.data.STATUS_ID);
  const onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "SaleInquiry.xlsx"
        );
      });
    });
  };
  //Column Chooser
  const [mode, setMode] = React.useState(columnChooserModes[1].key);
  const [searchEnabled, setSearchEnabled] = React.useState(true);
  const [allowSelectAll, setAllowSelectAll] = React.useState(true);
  const [selectByClick, setSelectByClick] = React.useState(true);
  const [recursive, setRecursive] = React.useState(true);
  const isDragMode = mode === columnChooserModes[0].key;
  const options = [
    { value: "1", label: "New" },
    { value: "2", label: "Processing" },
    { value: "3", label: "Done" },
    { value: "4", label: "Reject" },
    { value: "5", label: "Complete" },
    { value: "6", label: "Close" },
  ];
  const renderGridCell = (data: DataGridTypes.ColumnCellTemplateData) => (
    <a href={data.text} target="_blank" rel="noopener noreferrer">
      {data.text}
    </a>
  );

  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <label className="head">My Inquiry</label>
        </Grid>
        <Grid item xs={12} sm={3}></Grid>
        <Grid
          item
          xs={12}
          sm={3}
          style={{ display: "flex" }}
          justify="flex-end"
        >
          <Button1
            className="addBtn"
            disabled={!isButtonDisabled}
            type="button"
            variant="contained"
            color="primary"
            onClick={handleAddButtonClick}
          >
            New Inquiry
          </Button1>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={2}>
          <label>Start Date From</label>
          <DateBox
            styles={{
              menu: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
            defaultValue={now}
            inputAttr={dateLabel}
            type="date"
            displayFormat="dd/MM/yyyy"
            value={getDateFrom}
            onValueChanged={onValueChangedDateFrom}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>To</label>
          <DateBox
            defaultValue={now}
            inputAttr={dateLabel}
            type="date"
            displayFormat="dd/MM/yyyy"
            value={getDateTo}
            min={getMinDate}
            onValueChanged={onValueChangedDateTo}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Sales</label>
            <Select
            defaultValue={"-"}
            className="multiselect1"
            placeholder="Select..."
            value={getSale}
            options={saleList}
            onChange={handleSaleChange}
            getOptionLabel={(x) => x.SALE_NAME}
            getOptionValue={(x) => x.SALE_NAME}
            required
          />
          {/* <Select
            className="multiselect1"
            placeholder="Select..."
            value={getSale}
            options={saleList}
            onChange={handleSaleChange}
            getOptionLabel={(x) => x.EmpEmail}
            getOptionValue={(x) => x.EmpEmail}
            required
          /> */}
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Status</label>
          <Select
            className="react-select-container"
            placeholder="Select"
            value={getStatus}
            options={options}
            onChange={handleStatusChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className="paddingSearchButton">&nbsp;</div>
          <Button1
            className="searchButton"
            type="button"
            variant="contained"
            color="primary"
            onClick={handleSearch}
          >
            Search
          </Button1>
          &nbsp;&nbsp;&nbsp;
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="primary"
            onClick={handleClearInputClick}
          >
            Clear Filter
          </Button1>
          &nbsp;&nbsp;&nbsp;
        </Grid>
      </Grid>
      <Grid container className={classes.root}>
        <DataGrid
          onCellPrepared={cellPrepared}
          dataSource={salesinquirydataSource}
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={false}
          showScrollbar={true}
          keyExpr="INQUIRY_ID"
          onExporting={onExporting}
          hoverStateEnabled={true}
          allowColumnReordering={true}
          onContentReady={onContentReady}
          height={height}
          repaintChangesOnly={true}
        >
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
               //mode="virtual"
          ></Scrolling>
           <StateStoring
                      enabled={true}
                      type="localStorage"
                      storageKey="storageSalesInquiry"
                    />
          <MasterDetail enabled={true} component={InquiryMasterDetailView} />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          {/* <Selection mode="multiple" /> */}
          <SearchPanel
            visible={true}
            width={240}
            placeholder="Full Text Search..."
          />
          <Column
            dataField="INQUIRY_ID"
            caption="ID"
            dataType="number"
            width={50}
            alignment="left"
            defaultSortOrder="desc"
          />
          <Column
            dataField="INSERT_DATE"
            caption="START"
            dataType="date"
            format="dd-MMM-yyyy HH:mm:ss"
            allowHiding={false}
            width={140}
          />
          <Column
            dataField="COMPLETE_DATE"
            caption="COMPLETE"
            dataType="date"
            format="dd-MMM-yyyy HH:mm:ss"
            visible={false}
            width={150}
            customizeText={customizeText}
          />
          <Column dataField="STATUS_ID" visible={false} />
          <Column
            dataField="STATUS_NAME"
            caption="STATUS"
            allowHiding={false}
            width={100}
          />
          <Column
            dataField="Business_name"
            caption="BUSINESS TYPE"
            allowHiding={false}
            width={100}
          />
          <Column
            dataField="Customer_name"
            caption="SHIPPER"
            allowHiding={false}
          />
          <Column
            dataField="SHIPPER_DETAIL"
            caption="SHIPPER DETAIL"
            visible={false}
          />
          <Column dataField="POR" visible={false} />
          <Column dataField="POL" allowHiding={false} />
          <Column dataField="POD" allowHiding={false} />
          <Column dataField="DEL" visible={false} />
          <Column dataField="POR_NAME" visible={false} />
          <Column dataField="POD_NAME" visible={false} />
          <Column dataField="POL_NAME" visible={false} />
          <Column dataField="DEL_NAME" visible={false} />
          <Column dataField="DESTINATION_NAME" visible={false} />
  
          <Column
            dataField="COMMODITY"
            width={100}
            allowHiding={false}
          />
          <Column dataField="HS_CODE" caption="HS CODE" visible={false} />
          <Column
            dataField="COMMODITY_DETAIL"
            caption="COMMODITY DETAIL"
            visible={false}
          />
          <Column dataField="DANGEROUS" visible={false} />
          <Column dataField="DG_CLASS" visible={false} />
          <Column
            dataField="CONTAINER_SIZE"
            caption="SIZE"
            allowHiding={false}
            width={70}
          />
          <Column
            dataField="CONTAINER_TYPE"
            caption="TYPE"
            allowHiding={false}
            width={70}
          />
          <Column dataField="QUANTITY" caption="VOL" visible={false} />
          <Column dataField="WEIGHT" visible={false} />
          <Column dataField="DIMENSION" visible={false} />
          <Column dataField="CBM" visible={false} />
          <Column dataField="CARRIER" visible={false} />
          <Column dataField="USERNAME" visible={false} />
          <Column dataField="LASTUPDATE" visible={false} />
          <Column
            dataField="TARGET_RATE"
            caption="TARGET RATE"
            visible={false}
          />
          <Column
            dataField="REQUEST_STATUS"
            caption="REQUEST STATUS"
            visible={false}
          />
          <Column dataField="SALE_NAME" caption="SALES IN CHARGE" width={120} />
          <Column dataField="REC_NAME" caption="RECEIVE BY" width={100} />
          <Column dataField="REMARK" visible={false} />
          <Column dataField="BELL" caption="Comment"  hint="Click to copy comment" width={40} />
          <Column type="buttons" caption="Actions" width={100}>
            <Button
              icon="eyeopen"
              onClick={onEditButtonClick}
              hint="Click to view inquiry details"
            />
 
            <Button
              icon="email"
              onClick={onEmailButtonClick}
              hint="Click to send email"
              visible={isEmailIconVisible}
            />
             <Button
              icon="copy"
              name="copy"
              onClick={onCopyButtonClick}
              hint="Click to copy inquiry"
              visible={isCopyIconVisible}
            />
          </Column>
          
          {/* <Column type="buttons" caption="Feedback" width={40}>
          <Button
              icon="favorites"
              onClick={onRatingButtonClick}
              visible={isRatingIconVisible}
              hint="Feedback"
            />
          </Column> */}
          {/* <Column type="buttons" caption="Copy" width={50}>
           
          </Column> */}
          <LoadPanel enabled={true} />
          <ColumnChooser enabled={true} mode={mode}>
            <Position
              my="right top"
              at="right bottom"
              of=".dx-datagrid-column-chooser-button"
            />

            <ColumnChooserSearch
              enabled={searchEnabled}
              editorOptions={searchEditorOptions}
            />

            <ColumnChooserSelection
              allowSelectAll={allowSelectAll}
              selectByClick={selectByClick}
              recursive={recursive}
            />
          </ColumnChooser>
          <LoadPanel enabled={true} />
          <Export enabled={true} allowExportSelectedData={true} />
              <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                    <Paging defaultPageSize={25} />
        </DataGrid>
      </Grid>
    </Container>
  );
}
